<template>
  <a href="#" @click.prevent="click">
    <aw-icon icon="team" class="w-5 h-5 "></aw-icon>
    {{$t('Add team')}}
  </a>
</template>

<script>
export default {
  methods: {
    click() {
      this.$formValues['frm-addTeamForm-addTeamForm-parentId'] = ''
      this.$store.commit('nette/updateControl', {
        controlName: 'addTeamForm',
        data: true,
        key: 'showModal',
      })
    }
  },
}
</script>

<style lang="scss" scoped></style>
